import React from "react";
import { Col } from "react-bootstrap";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
} from "recharts";
import _isEmpty from "lodash/isEmpty";
import StartupDashboardWidget from "./StartupDashboardWidget";

const RegionSalesChartWidget = ({ productLineAnalytics }) => {
  if (!productLineAnalytics) {
    return <RegionSalesChartWidgetForFetchingData />;
  }

  const {
    absolute_sales_count_per_region_chart_data:
      absoluteSalesCountPerRegionChartData,
  } = productLineAnalytics;
  if (
    !absoluteSalesCountPerRegionChartData ||
    _isEmpty(absoluteSalesCountPerRegionChartData)
  ) {
    return <RegionSalesChartWidgetForNonExistingData />;
  }

  return (
    <RegionSalesChartWidgetContainer style={{ minHeight: "300px" }}>
      <Col md={12} style={{ minHeight: "300px", height: "300px" }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={absoluteSalesCountPerRegionChartData}
            margin={{
              top: 10,
              right: 30,
              left: 50,
              bottom: 0,
            }}
            layout="vertical"
          >
            <XAxis type="number" interval="preserveStartEnd" />
            <YAxis
              type="category"
              dataKey="region"
              tick={{ fontSize: 12 }}
              width={180}
            />
            <CartesianGrid strokeDasharray="3 3" />
            <Bar dataKey="value" fill="#1b66b3" label={<BarLabel />} />
          </BarChart>
        </ResponsiveContainer>
      </Col>
    </RegionSalesChartWidgetContainer>
  );
};

const BarLabel = ({ x, y, value, width, height }) => (
  <text
    x={x + width - 5}
    y={y}
    dy={height / 2 + 5}
    fill="#fff"
    fontSize={14}
    textAnchor="end"
  >
    {Intl.NumberFormat("de-DE", { maximumFractionDigits: 2 }).format(value)}
  </text>
);

const RegionSalesChartWidgetHeader = () => (
  <span className="dashboard-box-header-title">
    Gesamtabverkauf pro EDEKA Region
  </span>
);

const RegionSalesChartWidgetSubHeader = () => (
  <span className="text-right pull-right">Letzten 12 Wochen</span>
);

const RegionSalesChartWidgetForNonExistingData = () => (
  <RegionSalesChartWidgetContainer>
    <Col md={12}>
      <div style={{ textAlign: "center", marginTop: "20px" }}>
        Keine Abverkaufszahlen vorhanden
      </div>
    </Col>
  </RegionSalesChartWidgetContainer>
);

const RegionSalesChartWidgetForFetchingData = () => (
  <RegionSalesChartWidgetContainer>
    <Col md={12}>
      <div style={{ textAlign: "center", marginTop: "20px" }}>
        Abverkaufsdaten werden geladen ...
      </div>
    </Col>
  </RegionSalesChartWidgetContainer>
);

const RegionSalesChartWidgetContainer = props => (
  <StartupDashboardWidget
    id="region-sales-chart-widget"
    header={<RegionSalesChartWidgetHeader />}
    subHeader={<RegionSalesChartWidgetSubHeader />}
    {...props}
  >
    {props.children}
  </StartupDashboardWidget>
);

export default RegionSalesChartWidget;
